<template>
  <div class="content">
    <v-row>
      <v-col cols="6">
        <h1 class="title">{{ $t("users.title") }}</h1>
      </v-col>
      <v-col cols="6" align="end">
        <v-btn @click="handleCreateUser()" color="primary">{{
          $t("users.create")
        }}</v-btn>
      </v-col>
    </v-row>
    <div class="table">
      <table-list-users
        v-if="!isLoading"
        :headerList="tableHeaders"
        :userList="users"
        :seenAttrs="userSeenAttrs"
        :itemActionList="actions"
        @buttonClicked="handleActionClicked"
        @userChanged="handleUserEdit"
        @userDelete="handleUserDelete"
      />
      <v-card v-else class="loading">
        <v-progress-circular
          v-if="isLoading"
          size="73.5"
          indeterminate
          class="loading-circle"
        ></v-progress-circular>
      </v-card>
    </div>
  </div>
</template>

<script>
import TableListUsers from '@/components/global/tableListComponents/TableListUsers';
import { mapActions } from 'vuex';
import CreateUserModal from '@/components/global/modalComponents/CreateUserModal/CreateUserModal.vue';
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  name: "Users",
  props: {},
  components: {
    TableListUsers,
  },
  data() {
    return {
      users: [],
      userSeenAttrs: ["email", "role"],
      actions: [
        {
          icon: "mdi-edit",
          type: "edit",
        },
      ],
      isLoading: true,
    };
  },
  created() {
    this.emitter.on("buttonClicked", this.handleActionClicked);
    this.emitter.on("userDeleteConfirm", this.handleUserDelete);
    this.getUserList();
  },
  methods: {
    ...mapActions({
      getUsers: "users/getUsers",
      createUser: "users/createUser",
      editUser: "users/editUser",
      deleteUser: "users/deleteUser",
    }),
    getUserList() {
      this.isLoading = true;
      this.getUsers()
        .then((response) => {
          this.users = response.result;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleCreateUser() {
      this.emitter.emit("showComponentModalModal", {
        bind: {
          is: CreateUserModal,
        },
        on: {
          createNewUser: (createPayload) => {
            this.createUser(createPayload)
              .then(() => {
                toast.success(this.$t("users.toast.successCreate"));
                this.getUserList();
              })
              .catch(() => {
              })
          },
        },
        });
    },
    handleUserEdit(createPayload) {
      this.editUser(createPayload)
        .then(() => {
          toast.success(this.$t("users.toast.successEdit"));
          this.getUserList();
        })
        .catch(() => {});
    },
    handleUserDelete(user) {
      this.deleteUser(user)
        .then(() => {
          toast.success(this.$t("users.toast.successDelete"));
          this.getUserList();
        })
        .catch(() => {});
    },
  },
  computed: {
    tableHeaders() {
      const headers = [
        {
          title: this.$t("users.table.headers.email"),
          textAlign: "text-left",
          value: "email",
        },
        {
          title: this.$t("users.table.headers.role"),
          textAlign: "text-left",
          value: "role",
        },
        {
          title: this.$t("users.table.headers.actions"),
          textAlign: "text-right",
          value: "actions",
        },
      ];
      return headers;
    },
  },
  beforeUnmount() {
    this.emitter.off("userDeleteConfirm", this.handleUserDelete);
  },
};
</script>

<style lang="scss" scoped></style>
